import { BsFacebook, BsInstagram } from "react-icons/bs";
import { FaTripadvisor, FaTiktok } from "react-icons/fa";
import "../Styles/SocialIcons.css";

function SocialIcons() {
  return (
    <div className="social_media" role="navigation" aria-label="Social media">
      <a
        href="https://www.facebook.com/oldhouseafantou"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        title="Facebook"
      >
        <BsFacebook className="icons" size={22} />
      </a>
      <a
        href="https://www.instagram.com/oldhouseafantou/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        title="Instagram"
      >
        <BsInstagram className="icons" size={22} />
      </a>
      <a
        href="https://www.tiktok.com/@oldhouseafantou"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        title="TikTok"
      >
        <FaTiktok className="icons" size={20} />
      </a>
      <a
        href="https://www.tripadvisor.com/Restaurant_Review-g488296-d2175648-Reviews-The_Old_House_Restaurant-Afandou_Rhodes_Dodecanese_South_Aegean.html"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TripAdvisor"
        title="TripAdvisor"
      >
        <FaTripadvisor className="icons" size={24} />
      </a>
    </div>
  );
}

export default SocialIcons;
